import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { useLocation, useNavigate } from "react-router-dom";
import DateRange from "../../components/DateRange/DateRange";
import { Search_icon } from "../../assets/img";
import { toast } from "react-toastify";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import moment from "moment";
import { post } from "../../Services/ApiHandler";
import { RZP_KEY, URLS } from "../../Services/Constant";
import { useRazorpay } from "react-razorpay";
import { checkPermission } from "../redux/api/PermissionManager";

const MMCSuspendView = () => {
  const { error, isLoading, Razorpay } = useRazorpay();
  const navigate = useNavigate();
  const location = useLocation();
  const property = location.state?.property;
  const [popup, setPopup] = useState(false);
  const [desc, setDesc] = useState("");
  const [details, setDetails] = useState([]);

  const [selectedFilter, setSelectedFilter] = useState({
    from: "",
    to: "",
    search: "",
  });

  useEffect(() => {
    let prop = location.state?.property;
    if (prop?.id) {
      viewProperty(prop?.id);
    }
  }, []);

  useEffect(() => {
    console.log("error accured", error);
    if (error) {
      toast.error(error);
    }
  }, [error]);

  console.log("property view", property);
  const viewProperty = async (id) => {};

  const handleSubmit = () => {
    if (details.length === 0) {
      toast.error("Add Description");
      return;
    }
    navigate(-1);
  };

  const handleReject = () => {
    if (!desc) {
      toast.error("Enter Description");
      return;
    }
    if (desc.trim() !== "") {
      setDetails([...details, desc.trim()]);
      setDesc("");
      setPopup(false);
    }
  };

  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const FilteringData = (data) => {
    let filtered_list = [];
    if (selectedFilter.from && selectedFilter.to) {
      filtered_list = data.filter((item) => {
        const itemDate = moment(item.created_at, "YYYY-MM-DD");
        const from = selectedFilter.from
          ? moment(selectedFilter.from, "YYYY-MM-DD")
          : null;
        const to = selectedFilter.to
          ? moment(selectedFilter.to, "YYYY-MM-DD")
          : null;

        if (from && itemDate.isBefore(from)) return false;
        if (to && itemDate.isAfter(to)) return false;
        return true;
      });
    } else {
      filtered_list = data;
    }
    return filtered_list?.filter(
      (item) =>
        item
          .toLocaleUpperCase()
          .indexOf(selectedFilter.search.toLocaleUpperCase()) >= 0,
    );
  };

  const paymentInitiate = async (owner_id, property_id) => {
    const res = await post(`${URLS.CREATE_MMC}${owner_id}/${property_id}/`);
    if (res?.status === "success") {
      const d = res?.data;
      const RazorpayOrderOptions = {
        key: RZP_KEY,
        image:
          "https://frontend.newvow.vowstays.com/static/media/logo-icon.adcfba19588c3cc82c9a.png",
        amount: Number(d?.total_amount) * 100, // Amount in paise
        currency: "INR",
        name: "Vow",
        description: "Monthly Subscription",
        subscription_id: d?.razorpay_subscription_id,
        handler: (response) => {
          // console.log("razorpay response", response);
          confirmPayment(response);
        },
        theme: {
          color: "#AE55F5",
        },
      };
      const razorpayInstance = new Razorpay(RazorpayOrderOptions);
      razorpayInstance.open();
    }
  };

  const confirmPayment = async ({
    razorpay_subscription_id,
    razorpay_signature,
    razorpay_payment_id,
  }) => {
    const payload = {
      success: "active",
      razorpay_payment_id: razorpay_payment_id,
      razorpay_signature: razorpay_signature,
      razorpay_subscription_id: razorpay_subscription_id,
    };

    const res = await post(URLS.VERIFY_MMC, payload);
    if (res?.status === "success") {
      toast.success("Payment Success");
    }
  };

  return (
    <div className="">
      <Topbar header={"MMC View"} subHead={"MMC Suspended"} />
      <div className="d-flex flex-wrap gap-5 pb-4">
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Property ID
          </p>
          <input
            className="input-box"
            value={property?.property_code}
            type="text"
            placeholder="Property ID"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Owner Name
          </p>
          <input
            className="input-box"
            value={property?.owner}
            type="text"
            placeholder="Owner Name"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Property Name
          </p>
          <input
            className="input-box"
            value={property?.property_name}
            type="text"
            placeholder="Property name"
          />
        </div>

        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Location
          </p>
          <input
            value={property?.location}
            className="input-box"
            type="text"
            placeholder="Location"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Type
          </p>
          <input
            value={property?.category}
            className="input-box"
            type="text"
            placeholder="Type"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Expiry Date
          </p>
          <input
            value={property?.expiry_date}
            className="input-box"
            type="text"
            placeholder="Expiry Date"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Suspended Date
          </p>
          <input
            value={moment(property?.suspended_date).format(
              "DD-MM-YYYY hh:mm A",
            )}
            className="input-box"
            type="text"
            placeholder="Suspended Date"
          />

          {checkPermission("CAN-EDIT-MMC_SUSPENDED") && (
            <button
              onClick={() => {
                paymentInitiate(property?.owner_id, property?.property_id);
              }}
              className="active-btn mt-4 px-1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18"
            >
              Repay
            </button>
          )}
        </div>
      </div>
      <div className="d-flex ac-je mt-5 gap-3">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
          />
          <img src={Search_icon} className="search here" />
        </div>
        {checkPermission("CAN-ADD-MMC_SUSPENDED") && (
          <button onClick={() => setPopup(true)} className="active-btn">
            Add
          </button>
        )}
      </div>

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb  mb-4">
              <p className="f3 text-start fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
                Description
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setPopup(false);
                  setDesc("");
                }}
                className="pointer"
              />
            </div>
            <textarea
              style={{ minHeight: "130px", maxHeight: "300px" }}
              placeholder="Describe.."
              className="input-box"
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
            ></textarea>
            <div className="d-flex ac-jc px-2 mt-4">
              <button
                onClick={() => {
                  handleReject();
                }}
                className="submit-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}Submit
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="mt-5">
        <div className="d-flex ac-jb">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-20 box-table">
            Ticket ID
          </h4>
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-20 box-table">
            Admin Name
          </h4>
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-40 box-table">
            Description
          </h4>
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-20 box-table">
            Date & Time
          </h4>
        </div>

        {FilteringData(details).map((item) => {
          return (
            <div className="d-flex">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 red w-20 box-table">
                ZT6SD4HO
              </h4>
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  w-20 box-table">
                Midhun
              </h4>
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  w-40 box-table">
                {item}
              </h4>
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  w-20 box-table">
                08-07-2025, 12:35pm
              </h4>
            </div>
          );
        })}
      </div>

      <div className="d-flex ac-jb mt-5">
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default MMCSuspendView;
